import React, { Component } from 'react';
import { Link } from "react-router-dom";
import './BuildView.css';
import SideBar from '../../components/SideBar/SideBar.js';
import ArticleList from '../../components/ArticleList/ArticleList.js'
import Button from '../../components/Button/Button.js'
import Alert from '../../components/Alert/Alert.js'
import Nav from '../Nav/Nav.js'

export default class BuildView extends Component {

constructor(props, context) {
    super(props, context);

    this.state = {
      searchTerm: '',
      loggedIn: false,
      dataLoading: true,
      moduleName: '',
      moduleDescription: '',
      articleArray: [],
      wizard: [],
      searchLoader: '',
      dataList: '',
      activeListItem: '',
      moduleID: '',
      showPreview: '',
      articleType: '',
      articleIndex: '',
      pathOverIndex: '',
      buttonText: 'Save',
      buttonState: '',
      showAlert: false,
      alertText: '',
      alertState: '',
      alertType: 'positive',
      dropImageState: 'dropImage',
      errorMessage: '',
      apiUrl: '',
      zendeskURL: process.env.REACT_APP_ZENDESKURL,
      userData: []
    };


    this.getmoduleData = this.getmoduleData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
    this.searchZendesk = this.searchZendesk.bind(this);
    this.submitSearch = this.submitSearch.bind(this);
    this.onDragOver = this.onDragOver.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.onDragStart = this.onDragStart.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);

  }

  componentDidMount(){
     if(window.location.hostname === 'localhost')
      {
        this.setState({
          apiUrl: 'http://127.0.0.1:3030'
        },function(){
          this.init();
        })
      }else{
        this.setState({
          apiUrl: 'http://trainer.activepipe.com:3030'
        },function(){
          this.init();
        })
      }

  }


  /*---------------------------------------
      INITIALIZE
  -----------------------------------------*/
  init(){

    if(localStorage.userData){
      // console.log(localStorage.userData);

      this.setState({
          userData: JSON.parse(localStorage.userData),
          loggedIn: true
      },function(){

          if(this.props.moduleID){
            this.getmoduleData(this.props.moduleID)
          }else{
            this.setState({
             dataLoading: false
            })
          }

      })
    }else{
      window.location.href = '/login'
    }

  }
  /*---------------------------------------
      GET MODULE DATA
  -----------------------------------------*/
  getmoduleData(id) {

    this.setState({
      moduleID: id
    })

    const url = this.state.apiUrl + '/getModule';

    fetch(url, {
      method: 'POST',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: id
      })
    })
    .then((response) => response.json())
    .then((responseJson) =>
    {

        this.setState({
          moduleName: responseJson[0].name,
          moduleDescription: responseJson[0].description,
          wizard: JSON.parse(responseJson[0].path),
          dataLoading: false
        })


        if(this.state.wizard.length > 0){
          this.setState({
            dropImageState: '',
            showPreview: true
          })
        }



    }).catch((error) => {
        console.log("Error");
        console.error(error);
    });

  }
  /*---------------------------------------
      FUNCTIONS
  -----------------------------------------*/


  /// Search Zendesk
  searchZendesk(query){

    this.setState({
      searchLoader: 'inputLoading',
      errorMessage: '',
    });
    var url = this.state.zendeskURL + '/articles/search.json?query=' + query

    fetch(url, {
      method: 'GET'
    })
    .then((response) => response.json())
      .then((responseJson) =>
      {


        if(responseJson.count < 1){
          this.searchById(query)
        }else{
            this.setState({
              articleArray: responseJson.results,
              searchLoader: ''
            })
        }

      })
      .catch((error) => {
        this.alert("Oh no! We can't seem to connect to Zendesk!",'negative', 5000)
        console.log("Errror");
        console.error(error);
        this.setState({
          searchLoader: ''
        })
      });

  }

  searchById(query){

    var url = this.state.zendeskURL + '/articles/'+ query

    fetch(url, {
      method: 'GET'
    })
    .then((response) => response.json())
      .then((responseJson) =>
      {

        if(responseJson.article){
          var test = [];
          test.push(responseJson.article)
           this.setState({
              articleArray: test,
              searchLoader: ''
            })
         }
         else{
            this.setState({
              articleArray: [],
              errorMessage: 'No results found',
              searchLoader: ''
            })
        }



      })
      .catch((error) => {
        // console.log("Errror");
        // console.error(error);
      });
  }


  /*---------------------------------------
      HANDLERS
  -----------------------------------------*/

  submitSearch(event){

    if(this.state.searchTerm.length>0){
      this.searchZendesk(this.state.searchTerm);
    }
    event.preventDefault();
  }

  handleChange(event) {
    this.setState({
      searchTerm: event.target.value
    });
  }

  removeArticle(index){
    this.state.wizard.splice(index,1);
    this.setState({wizard: this.state.wizard})

     if(this.state.wizard.length < 1){
          this.setState({
            dropImageState: 'dropImage'
          })
        }

  }

  /*---------------------------------------
      DRAG AND DROP
  -----------------------------------------*/
  onDragOver(e,index){

    // e.target.parentNode.classList.add('articleOver');

    this.setState({
      pathOverIndex: index
    })

    e.stopPropagation();
    e.preventDefault();

  }

  onDragOverZone(e){

    this.setState({
      pathOverIndex: this.state.wizard.length
    })

    e.stopPropagation();
    e.preventDefault();
  }

  onDragEnter(e,index)
  {
    // BETTER THAN DRAGOVER
    // e.target.parentNode.classList.add('articleOver');

  }

  onDragLeave(e,index){

    e.stopPropagation();
    e.preventDefault();
  }


  onDragEnd(e, index){

    // const element = e.target;

    // setTimeout(function(){
    //   element.classList.remove('articleOver');
    //   element.classList.remove('hide');
    // });

    const x = document.getElementsByClassName("zenArticleOver");
      while (x[0]) {
        x[0].classList.remove('zenArticleOver')
      }

  }

  onDrop(e,index,type){

    if(this.state.articleType !== 'zen'){

     // SORT ARRAY
      const element = this.state.wizard[this.state.activeListItem];
      this.state.wizard.splice(this.state.activeListItem, 1);
      this.state.wizard.splice(index, 0, element);
      this.setState({
        wizard: this.state.wizard,
        showPreview: false
      });

      const x = document.getElementsByClassName("zenArticleOver");
      while (x[0]) {
        x[0].classList.remove('zenArticleOver')
      }


    }


  }

  onDropZone(e){

    if(this.state.articleType === 'zen'){

      // GET READ TIME
      let bodyCopy = this.state.articleArray[this.state.articleIndex].body;
      let tempText = document.createElement('div');
      tempText.innerHTML = bodyCopy;
      let articleText = tempText.innerText || tempText.textContent;
      let readTime = articleText.split(/\W+/).length;
      readTime = Math.round(readTime/110);
      if(readTime < 1){readTime = 1;}
      tempText.remove()


      let newArticle = {
        'id': this.state.articleArray[this.state.articleIndex].id ,
        'name': this.state.articleArray[this.state.articleIndex].name,
        'readTime': readTime,
        'url': this.state.articleArray[this.state.articleIndex].html_url
      }

      this.state.wizard.splice(this.state.pathOverIndex, 0, newArticle);
      this.setState({
        wizard: this.state.wizard,
        showPreview: false,
        dropImageState: ''
      })

      setTimeout(() =>{

        const x = document.getElementsByClassName("fadeIn");
        while (x[0]) {
          x[0].classList.remove('fadeIn')
        }
        document.getElementsByClassName("articleMain")[this.state.pathOverIndex].classList.add('fadeIn')
      })
    }

  }

  onDragStart(e, index){

    e.target.classList.add('zenArticleOver');

    this.setState({
      activeListItem: index,
      articleType: 'path'
    });

    const element = e.target;
    setTimeout(function(){
      element.classList.add('hide');
    });
    // FIX FOR FIREFOX
    e.dataTransfer.setData('text','');
  }

  onDragStartArticle(e,index){

    e.target.classList.add('zenArticleOver');

    this.setState({
      articleType: 'zen',
      articleIndex: index
    });

    // FIX FOR FIREFOX
    e.dataTransfer.setData('text','');
  }

  /*---------------------------------------
      SAVING
  -----------------------------------------*/
  handleNameChange(event){
    this.setState({
      moduleName: event.target.value,
      showPreview: false
    });
  }

handleDescriptionChange(event){
  this.setState({
      moduleDescription: event.target.value,
      showPreview: false
    });
}
  savemodule(){

    if(this.state.moduleName.length < 1){
      this.alert('You need to name your Module!','warning', 2000)
      return;
    }

    this.setState(
    {
      buttonText: 'Saving...',
      buttonState: 'saving'
    })

    let body, url;
    if(this.state.moduleID){

      url = this.state.apiUrl + '/updateModule';

      body = {
          id: this.state.moduleID,
          name: this.state.moduleName,
          path: this.state.wizard,
          description: this.state.moduleDescription,
          modified: this.state.userData.name,
          modifiedID: this.state.userData.id
        }

    }else{

      url = this.state.apiUrl + '/saveModule';

      body = {
          name: this.state.moduleName,
          path: this.state.wizard,
          description: this.state.moduleDescription,
          modified: this.state.userData.name,
          modifiedID: this.state.userData.id
        }

    }



    fetch(url, {
      method: 'POST',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    })
    .then((response) => response.json())
    .then((responseJson) =>
    {

        if(!this.state.moduleID){
          this.setState({
            moduleID: responseJson
          })
          window.history.pushState('', '', '/build/' + responseJson);
        }

        setTimeout(() => {
          this.setState({
            buttonText: 'Success !' ,
            buttonState: 'success',
            showPreview: true
          })
        },750)

        setTimeout(() => {
          this.setState({
            buttonText: 'Save',
            buttonState: ''
          })
        },1500)


    })
    .catch((error) => {
        this.setState({
          buttonText: 'Save' ,
          buttonState: ''
        })
        this.alert('Oh no! Something went wrong! Try again maybe?','negative', 3000)
        console.log("Error");
        console.error(error);
    });



  }


/*---------------------------------------
    GET LINK
-----------------------------------------*/
copyLink(id){
  const str = 'http://trainer.activepipe.com/module/' + id;
  const el = document.createElement('textarea');
  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  this.alert('Link copied to clipboard','positive', 2000)
}

/*---------------------------------------
    ALERT
  -----------------------------------------*/

  alert(message, type, holdTime){
    this.setState({
      alertText: message,
      alertState: 'alertAppear',
      alertType: type,
      showAlert: true
    })
    setTimeout(()=>{
      this.setState({
      alertState: ''
      })
    },holdTime)
  }


  /*---------------------------------------
      RENDER
  -----------------------------------------*/
  render() {

    return (


      <div className="App">
      {this.state.loggedIn ?
        <div>

        {this.state.dataLoading ?
        <div className={"loader"}></div>
        : null}

        <Alert text={this.state.alertText} visible={this.state.alertState} type={this.state.alertType}/>
        <Nav />
        <SideBar>

          <form onSubmit={this.submitSearch}>
              <label>
                <span>Search using Text or Article ID</span>
                <input type="text" value={this.state.value} onChange={this.handleChange} placeholder="Search Zendesk" className={this.state.searchLoader}/>
              </label>
              <div className={"error"}>{this.state.errorMessage}</div>
          </form>

          <div className={"results"}>
              {
                this.state.articleArray.map((article, index) =>{
                  return(
                      <div
                      key={article.id}
                      id={article.id}
                      className={"article"}
                      draggable="true"
                      onDragStart={(e)=>this.onDragStartArticle(e, index)}
                      >
                      <a href={article.html_url} target="_blank" className={"linkIcon"}><img src={"../assets/images/icons/eye.svg"} alt="View Link" /></a>
                      <div className={"articleName"}>{article.name}</div>
                      </div>
                      )
                })
              }
          </div>

        </SideBar>

        <header>
          <label>
          <div>Public Name</div>
          <input type="text" value={this.state.moduleName} onChange={this.handleNameChange} placeholder="Enter Module Name" autoFocus/>
          </label>
          <div className={"rhs t"}>
            { this.state.showPreview ? <Link to={'/module/' + this.state.moduleID } target="preview" data-tooltip="Preview" className={"tooltip"}><img src={"../assets/images/icons/eye.svg"} alt="Preview" /></Link> : null}
            {this.state.moduleID ?
            <button className={'linkButton tooltip'} onClick={()=>this.copyLink(this.state.moduleID)}  data-tooltip="Copy Link"><img src={"../assets/images/icons/link.svg"} alt="Get Link" /></button>
            :null}
            <Button text={this.state.buttonText} clickAction={()=>this.savemodule()} buttonColor="blue" buttonState={this.state.buttonState}/>
          </div>
        </header>

        <div className={"description"}>
         <label>
          <div>Internal Description (not Public - Optional)</div>
          <input type="text" value={this.state.moduleDescription} onChange={this.handleDescriptionChange} placeholder="Make it short and clear" />
          </label>
        </div>

        <ArticleList>
        <div className={"dropzone " + this.state.dropImageState} onDragOver={(e)=>this.onDragOverZone(e)} onDrop={(e)=>this.onDropZone(e)}>
           {
            this.state.wizard.map((article, index) =>{
                return(
                      <div
                        key={index}
                        id={article.id}
                        className={"articleMain"}
                        draggable="true"
                        onDragStart={(e)=>this.onDragStart(e, index)}
                        onDragEnter={(e)=>this.onDragEnter(e, index)}
                        onDragOver={(e)=>this.onDragOver(e,index)}
                        onDragLeave={(e)=>this.onDragLeave(e)}
                        onDrop={(e)=>this.onDrop(e,index)}
                        onDragEnd={(e)=>this.onDragEnd(e,index)}
                      >

                      <div className={"articleInner"}>
                        <div className={"articleTitle"}>{article.name}</div>
                        <div className={"tools"}>
                          <a href={article.url} target="_blank" className={"icon"}><img src={"../assets/images/icons/eye.svg"} alt="View Link" /></a>
                          <button className={"icon"} onClick={()=>this.removeArticle(index)}><img src={"../assets/images/icons/trash.svg"} alt="Remove Article"/></button>
                          <button className={"icon grip"} ><img src={"../assets/images/icons/grip.svg"} alt="Order Articles"/></button>
                        </div>
                      </div>

                      </div>
                )
            })
         }
         </div>
        </ArticleList>


        </div>
        : null}
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/views/BuildView/BuildView.js